import Axios from '@/api/http'
import { baseurl, yqfkurl } from '../common.js'
/**
 * 登陆
 * */
export function login (query) {
  return Axios({
    method: 'post',
    url: '/api/login',
    data: query,
    withCredentials: true,
    baseURL: yqfkurl()
  })
}
/**
 * 微信扫码登陆
 * */
 export function qrcodelogin (query) {
  return Axios({
    method: 'post',
    url: 'api/qrcodelogin',
    data: query,
    withCredentials: true,
    baseURL: yqfkurl()
  })
}
/**
 * 单点登陆(统一登录)
 * */
export function onSign (query) {
  return Axios({
    method: 'post',
    url: '/out/unifylogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
    // https://yqfk.xmedu.cn/tripartiteLogin?appid=JxTn2MRu&returnUrl=http%3A%2F%2Fxmxxws.xmedu.cn%2Fjbjc%2FAuth%2FAuthIndex.aspx
    // 请求上述路径，登录报错。小林反馈说是调用的接口域名不对，因此先把代码还原回去
    // baseURL: yqfkurl()

  })
}
/**
 * 已登入用户生成新的token
 * */
export function onGetssotoken (query) {
  return Axios({
    method: 'post',
    url: '/api/getssotoken',
    data: query,
    withCredentials: true
  })
}

/**
 * 访客登录
 * */
export function getVisitor (query) {
  return Axios({
    method: 'post',
    url: '/api/getvisitor',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 第三方登陆
 * */
export function outlogin (query) {
  return Axios({
    method: 'post',
    url: '/out/outlogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * i教育研修登陆
 * */
export function yxlogin (query) {
  return Axios({
    method: 'post',
    url: '/api/yxptlogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 工业单点登陆
 * */
export function gylogin (query) {
  return Axios({
    method: 'post',
    url: '/api/gzptlogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * i厦大单点登陆
 * */
export function xiadalogin (query) {
  return Axios({
    method: 'post',
    url: '/api/ixiadalogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 黎大单点登陆
 * */
export function lmussologin (query) {
  return Axios({
    method: 'post',
    url: '/api/lmussologin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 鼓楼教育局单点登陆
 * */
export function fzgledulogin (query) {
  return Axios({
    method: 'post',
    url: '/api/fzgledulogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 夏商单点登录过来生成小程序scheme码唤醒小程序
 * */
export function xsmlogin (query) {
  return Axios({
    method: 'post',
    url: '/out/getxsusrlscheme',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 夏商PC端单点登陆
 * */
export function xsplogin (query) {
  return Axios({
    method: 'post',
    url: '/api/xspclogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 双十单点登陆
 * */
export function xmssoutlogin (query) {
  return Axios({
    method: 'post',
    url: '/out/xmssoutlogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 泉州职称单点登陆
 * */
export function qzoutlogin (query) {
  return Axios({
    method: 'post',
    url: '/out/qzoutlogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 学生资助单点登陆
 * */
export function xszzlogin (query) {
  return Axios({
    method: 'post',
    url: '/api/xszzlogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 同安新星学校单点登陆
 * */
export function taxxplogin (query) {
  return Axios({
    method: 'post',
    url: '/api/tatxjyhlogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}
/**
 * 疫情防控单点登陆
 * */
export function yqfklogin (query) {
  return Axios({
    method: 'post',
    url: '/api/yqfklogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 龙岩单点登录
 * */
export function lylogin (query) {
  return Axios({
    method: 'post',
    url: '/api/lyedulogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 龙岩单点登录绑定用户
 * */
export function lybindUser (query) {
  return Axios({
    method: 'post',
    url: '/api/lybinduser',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 翔安对接认证平台单点登录
 * */
export function xassologin (query) {
  return Axios({
    method: 'post',
    url: '/api/xassologin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 国贸-智慧中台单点登录OA页
 * */
export function itelogin (query) {
  return Axios({
    method: 'post',
    url: '/openapi/gmlogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 国贸-OA资讯单点登录
 * */
export function iteinformationlogin (query) {
  return Axios({
    method: 'post',
    url: '/openapi/gmoainformationlogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 国贸-OA考勤单点登录
 * */
export function iteattendancelogin (query) {
  return Axios({
    method: 'post',
    url: '/openapi/gmoaworkattendancelogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 国贸-OA系统单点登录
 * */
export function itegmoasystemlogin (query) {
  return Axios({
    method: 'post',
    url: '/openapi//gmoasystemlogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 国贸-OA投资管理单点登录
 * */
export function iteainvestmentlogin (query) {
  return Axios({
    method: 'post',
    url: '/openapi/gmoainvestmentlogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 国贸-OA财务预算单点登录
 * */
export function iteafinancelogin (query) {
  return Axios({
    method: 'post',
    url: '/openapi/gmoafinancelogin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 企业微信单点登录
 * */
export function wecompcssologin (query) {
  return Axios({
    method: 'post',
    url: '/openapi/wecompcssologin',
    data: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}

/**
 * 获取token
 * */
export function getaccesstoken (query) {
  return Axios({
    method: 'get',
    url: '/api/getaccesstoken',
    params: query,
    withCredentials: true,
    baseURL: yqfkurl()
  })
}
/**
 * 验证码登陆获取验证码---尚暖要求post
 */
export function getloginvalidcode (query) {
  return Axios({
    method: 'post',
    url: '/mobile/getloginvalidcode',
    data: query,
    withCredentials: true,
    baseURL: yqfkurl()
  })
}
/**
 * 验证码登陆
 */
export function validlogincode (query) {
  return Axios({
    method: 'get',
    url: '/api/validlogincode',
    params: query,
    withCredentials: true,
    baseURL: yqfkurl()
  })
}
/**
 * 获取滑动图片验证码
 */
 export function imagecaptcha (query) {
  return Axios({
    method: 'post',
    url: '/openapi/imagecaptcha',
    data: query,
  })
}

/**
 * 判断滑动验证码是否成功
 */
 export function checkimageverifycode (query) {
  return Axios({
    method: 'post',
    url: '/openapi/checkimageverifycode',
    data: query,
  })
}
/**
 * 获取短信验证码
 */
 export function getloginsmsvalidcode (query) {
  return Axios({
    method: 'post',
    url: '/mobile/getloginsmsvalidcode',
    data: query,
    withCredentials: true,
    baseURL: yqfkurl()
  })
}
/**
 * 短信验证码登录
 */
export function smsvalidlogincode (query) {
  return Axios({
    method: 'post',
    url: '/api/smsvalidlogincode',
    data: query,
    withCredentials: true,
    baseURL: yqfkurl()
  })
}
/**
 * 多账号短信验证码登录
 */
export function smsvalidcodemultipleaccountslogin (query) {
  return Axios({
    method: 'post',
    url: '/api/smsvalidcodemultipleaccountslogin',
    data: query,
    withCredentials: true,
    baseURL: yqfkurl()
  })
}
/**
 * 创建用户
 * */
export function createuser (query) {
  return Axios({
    method: 'get',
    url: '/api/createuser',
    params: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}
/**
 * 同步验证
 * */
export function checkuser (query) {
  return Axios({
    method: 'get',
    url: '/api/checkuser',
    params: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}
/**
 * 用户确认验证
 * */
export function userinfosynchr (query) {
  return Axios({
    method: 'get',
    url: '/api/userinfosynchr',
    params: query,
    withCredentials: true,
    baseURL: baseurl()
  })
}
/**
 * 客户端到中台数据存储接口
 * */
export function adduserlogininfo (query) {
  return Axios({
    method: 'post',
    url: '/openapi/adduserlogininfo',
    data: query
  })
}
/**
 * 获取人脸对比日志列表
 * */
export function getfaceloglist (query) {
  return Axios({
    method: 'post',
    url: '/api/getfaceloglist',
    data: query
  })
}
/**
 * 登录页获取登录页配置
 * */
export function getloginweb (query) {
  return Axios({
    method: 'post',
    url: '/out/getloginweb',
    data: query
  })
}
/**
 * 获取登录验证码弹出条件
 * */
export function getsecurityrules (query) {
  return Axios({
    method: 'post',
    url: '/api/getsecurityrules',
    data: query
  })
}
/**
 * 获取密码安全设置
 * */
export function getpwdconfig (query) {
  return Axios({
    method: 'post',
    url: '/api/getpwdconfig',
    data: query
  })
}
/**
 * 获取访客登录信息 通过skey
 * */
export function outhreflogin (query) {
  return Axios({
    method: 'post',
    url: '/out/outhreflogin',
    data: query
  })
}
/**
 * 中台来的，切换登陆查看
 * */
export function ztclicklogin (query) {
  return Axios({
    method: 'post',
    url: '/api/ztclicklogin',
    data: query
  })
}
export function changelogin (query) {
  return Axios({
    method: 'post',
    url: '/out/changelogin',
    data: query
  })
}
export function getuserbyphone (query) {
  return Axios({
    method: 'post',
    url: '/out/getuserbyphone',
    data: query
  })
}
/**
 * 微信安全注册-获取微信扫码二维码
 * */
export function registercreateqrcode (query) {
  return Axios({
    method: 'post',
    url: '/out/registercreateqrcode',
    data: query
  })
}
/**
 * 微信安全注册-获取公众号openid
 * */
export function getmpopenid (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getmpopenid',
    data: query
  })
}
/**
 * 微信安全注册-登录成功返回消息推送
 * */
export function sendloginmpmessage (query) {
  return Axios({
    method: 'post',
    url: '/openapi/sendloginmpmessage',
    data: query
  })
}
/**
 * 微信安全注册-注册资料选填
 * */
export function updateregisteruser (query) {
  return Axios({
    method: 'post',
    url: '/openapi/updateregisteruser',
    data: query
  })
}
export function getphonemultipleaccounts (query) {
  return Axios({
    method: 'post',
    url: '/api/getphonemultipleaccounts',
    data: query
  })
}
/**
 * 第三方登录域名判断
 * */
export function thirdUrlShow () {
  let URL = '';
  if ((window.location.href).indexOf("localhost") !== -1) {
    //- i厦门测试域名
    URL = 'https://test.ixiamen.org.cn/ids/custom/xiamen/login_xm.jsp?loginType=Citizen&returnUrl=https://test.ixiamen.org.cn/ids/custom/xiamen/autoSubmitForProxyLogin.jsp?coAppName=SSJKSBXT';
  } else if ((window.location.href).indexOf("edu.topeti.com") !== -1) {
    //- i厦门测试域名
    URL = 'https://test.ixiamen.org.cn/ids/custom/xiamen/login_xm.jsp?loginType=Citizen&returnUrl=https://test.ixiamen.org.cn/ids/custom/xiamen/autoSubmitForProxyLogin.jsp?coAppName=SSJKSBXT';
  } else {
    //- i厦门正式域名
    URL = 'https://www.ixiamen.org.cn/ids/custom/xiamen/login_xm.jsp?loginType=Citizen&returnUrl=https://www.ixiamen.org.cn/ids/custom/xiamen/autoSubmitForProxyLogin.jsp?coAppName=SSJKSBXT';
    // URL = 'https://test.ixm.gov.cn/ids/custom/xiamen/login_xm.jsp?loginType=Citizen&returnUrl=https://test.ixm.gov.cn/ids/custom/xiamen/autoSubmitForProxyLogin.jsp?coAppName=SSJKSBXT';
  }
  return URL;
}

